import CreditDisplay from "terriajs-cesium/Source/Scene/CreditDisplay";
import parseCustomHtmlToReact from "../../../Custom/parseCustomHtmlToReact";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const MapCreditLogo = _ref => {
  let {
    currentViewer
  } = _ref;
  if (currentViewer.type === "Leaflet") {
    const prefix = currentViewer.attributionPrefix;
    if (prefix) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: parseCustomHtmlToReact(prefix)
      });
    }
    return null;
  }
  return parseCustomHtmlToReact(CreditDisplay.cesiumCredit.html, {
    disableExternalLinkIcon: true
  });
};